import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { HttpClient, HttpHeaders, HttpParams, HttpErrorResponse } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { ToastrService } from 'ngx-toastr';
import Swal from 'sweetalert2'

@Injectable({
  providedIn: 'root'
})
export class GeraNovaSenhaService {

  NovaSenhaGerada$ = new BehaviorSubject<string>(null);

  constructor(private http: HttpClient) { }

  gera(alteracaoSenha: any) {
    try {
      var headers = new HttpHeaders();
      headers.append('Content-Type', 'application/x-www-form-urlencoded');

      var url: string = environment.advCorpLoginApi + '/api/NovaSenha';

      Swal.fire({
        title: "",
        text: "Carregando...",
        icon: "warning",
        timer: 1500,
        showCancelButton: false,
        showConfirmButton: false
      });

      this.http.post(url, alteracaoSenha).subscribe({
        next: (res: any) => {
          // console.log(res);
          this.NovaSenhaGerada$.next(res);
          if (this.NovaSenhaGerada$.value == 'Sucesso') {
            Swal.fire({
              title: "",
              text: "Nova senha gerada com Sucesso! Verifique seu E-mail!",
              icon: "success",
              timer: 1500,
              showCancelButton: false,
              showConfirmButton: false
            });
            setTimeout(function () {
              window.location.reload();
            }, 2000);
          } else {
            Swal.fire('Oops...', this.NovaSenhaGerada$.value, 'error');
          }
        },
        complete: () => {
          if (this.NovaSenhaGerada$) {
            this.NovaSenhaGerada$ = new BehaviorSubject<string>(null);
          }
        },
        error: (error: HttpErrorResponse) => {
          if (error.status == 400) {
            Swal.fire('Eiii!?...', 'Acesso inválido, por favor tente novamente!', 'error');
          } else if (error.status === 500) {
            Swal.fire({
              'width': 500,
              'title': 'Oops...',
              'text': error.error.detail,
              'icon': 'error'
            });
          } else {
            Swal.fire('Oops...', 'Algo deu errado, por favor entre em contato com o Suporte!', 'error');
          }
        }
      });
    } catch (e) {
      Swal.fire({
        title: "Oops...",
        text: "Algo deu errado, por favor entre em contato com o Suporte!",
        icon: "error",
        timer: 1500,
        showCancelButton: false,
        showConfirmButton: true
      });
    }
  }
}